module.exports = __webpack_public_path__ + "img/login1.ee4d6977.png";